// Change this value to see the stories with the theme v1 or v2 applied
export const USE_PIXEL_PARTY_THEME_V2 = false;
